namespace GeniuzPOS.ReportMasterData {
    export class Report_1313Columns {
        static columnsKey = 'ReportMasterData.Report_1313';
    }
}
